import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import VendorPartnerships from './components/VendorPartnerships';
import MarketingSolutions from './components/MarketingSolutions';
import Testimonials from './components/Testimonials';
import Statistics from './components/Statistics';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [isNavbarScrolled, setIsNavbarScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsNavbarScrolled(true);
    } else {
      setIsNavbarScrolled(false);
    }
  };

  useState(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isNavbarScrolled} />
      <Hero />
      <About />
      <Services />
      <VendorPartnerships />
      <MarketingSolutions />
      <Testimonials />
      <Statistics />
      <Contact />
      <Footer />
    </div>
  );
}
